module.exports = __webpack_public_path__ + "img/1.3e652584.png";